var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleMinus = function SvgCircleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8B8B8B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.935 18.674c4.583 0 8.333-3.746 8.333-8.324s-3.75-8.323-8.333-8.323-8.333 3.745-8.333 8.323 3.75 8.324 8.333 8.324M6.602 10.349h6.666"
  })));
};
export { SvgCircleMinus as ReactComponent };
export default __webpack_public_path__ + "0f55294e2c39b1a1dad4d6932b83f113.svg";